import './index.css';
import Dashboard from './Dashboard/Dashboard';
import TimelineView from './Dashboard/TimelineView/TimelineView';
import Sidebar from './Layout/Sidebar';
import LockedTestDetails from './TestSeries/LockedTestsListing/LockedTestDetails';
import UnlockedTestListing from './TestSeries/UnlockedTestListing/UnlockedTestListing';
import UnlockedTestDetails from './TestSeries/UnlockedTestListing/UnlockedTestDetails';
import NoTestSeries from './TestSeries/NoTestSeriesBought/NoTestSeries';
import LockedTest from './TestSeries/LockedTestsListing/LockedTest';
import MyMistakes from './MyMistakes/MyMistakes';
import SolutionsV3 from './Solutions/Solutions';
import Resources from './Resources/Resources';
import Lectures from './Lectures/Lectures';
import TestAnalysisV3 from './TestAnalysis/TestAnalysis';
import TestAnalysisCombined from './TestAnalysis/TestAnalysisCombined';
import ChapterWiseMistakesDetailed from './MyMistakes/ChapterWiseMistakes/ChapterWiseMistakesDetailed';
import TestWiseMistakesDetailed from './MyMistakes/TestWiseMistakes/TestWiseMistakesDetailed';
import NotebookFinal from './Notebook/NotebookFinal';
import ProfileFinal from './Profile/ProfileFinal';
import Leaderboard from './LeaderBoard/LeaderBoard';
import Login from './Auth/Login';
import ErrorPage from './ErrorPage/ErrorPage';
import TestSubmission from './TestSubmission/TestSubmission';
import PackAnalysisFinal from './PackAnalysis/PackAnalysisFinal';
import ExploreQuizrr from './ExploreQuizrr/ExploreQuizrr';
import Challenge99Landing from './Challenge99/Challenge99Landing';
import Challenge99Home from './Challenge99/Challenge99Home';
import ChallengeInternalGateSheet from './Challenge99/ChallengeInternalGateSheet';
import MaintenancePage from './MaintenancePage/MaintenancePage';
import { RegisterForm, RegisterVerify } from './Auth/Register';
import { ResetRequest, ResetConfirm } from './Auth/Reset';

const user = JSON.parse(localStorage.getItem('userProfile'));
const root = window.document.documentElement;

if (user?.settings?.isDarkTheme) {
  root.classList.add('dark');
} else {
  root.classList.add('light');
}

export {
  Dashboard,
  Sidebar,
  LockedTestDetails,
  UnlockedTestListing,
  UnlockedTestDetails,
  NoTestSeries,
  LockedTest,
  MyMistakes,
  SolutionsV3,
  ChapterWiseMistakesDetailed,
  TestWiseMistakesDetailed,
  NotebookFinal,
  ProfileFinal,
  TestAnalysisV3,
  TestAnalysisCombined,
  Leaderboard,
  Login,
  RegisterForm,
  RegisterVerify,
  ResetRequest,
  ResetConfirm,
  Resources,
  Lectures,
  ErrorPage,
  MaintenancePage,
  ExploreQuizrr,
  Challenge99Landing,
  Challenge99Home,
  ChallengeInternalGateSheet,
  PackAnalysisFinal,
  TestSubmission,
  TimelineView,
};
